const HANDLER_KEY = Symbol('fmOnClickOutside')

function isEventOutside(event, element) {
  const path = typeof event.composedPath === 'function' ? event.composedPath() : []

  if (path.length) {
    return !path.includes(element)
  }

  return !element.contains(event.target)
}

function bindClickOutside(element, binding) {
  const callback = binding.value

  if (typeof callback !== 'function') return

  const handler = event => {
    if (isEventOutside(event, element)) {
      callback(event)
    }
  }

  element[HANDLER_KEY] = handler
  document.addEventListener('pointerdown', handler, true)
}

function unbindClickOutside(element) {
  const handler = element[HANDLER_KEY]

  if (handler) {
    document.removeEventListener('pointerdown', handler, true)
    delete element[HANDLER_KEY]
  }
}

export const vOnClickOutside = {
  mounted: bindClickOutside,
  updated(element, binding) {
    if (binding.value === binding.oldValue) return

    unbindClickOutside(element)
    bindClickOutside(element, binding)
  },
  beforeUnmount: unbindClickOutside,
}
